"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IHederaTokenManager__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "AdminKeyUpdateError",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "s",
                type: "string",
            },
        ],
        name: "MoreThan100Error",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "RefundingError",
        type: "error",
    },
    {
        inputs: [],
        name: "SupplyKeyUpdateError",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "admin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "string",
                name: "metadata",
                type: "string",
            },
        ],
        name: "MetadataSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: false,
                internalType: "int64",
                name: "amount",
                type: "int64",
            },
        ],
        name: "TokenTransfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "string",
                        name: "tokenName",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "tokenSymbol",
                        type: "string",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "keyType",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes",
                                name: "publicKey",
                                type: "bytes",
                            },
                            {
                                internalType: "bool",
                                name: "isED25519",
                                type: "bool",
                            },
                        ],
                        internalType: "struct KeysLib.KeysStruct[]",
                        name: "keys",
                        type: "tuple[]",
                    },
                    {
                        internalType: "int64",
                        name: "second",
                        type: "int64",
                    },
                    {
                        internalType: "int64",
                        name: "autoRenewPeriod",
                        type: "int64",
                    },
                    {
                        internalType: "string",
                        name: "tokenMetadataURI",
                        type: "string",
                    },
                ],
                indexed: false,
                internalType: "struct IHederaTokenManager.UpdateTokenStruct",
                name: "updateTokenStruct",
                type: "tuple",
            },
        ],
        name: "TokenUpdated",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getMetadata",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "string",
                        name: "tokenName",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "tokenSymbol",
                        type: "string",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "keyType",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes",
                                name: "publicKey",
                                type: "bytes",
                            },
                            {
                                internalType: "bool",
                                name: "isED25519",
                                type: "bool",
                            },
                        ],
                        internalType: "struct KeysLib.KeysStruct[]",
                        name: "keys",
                        type: "tuple[]",
                    },
                    {
                        internalType: "int64",
                        name: "second",
                        type: "int64",
                    },
                    {
                        internalType: "int64",
                        name: "autoRenewPeriod",
                        type: "int64",
                    },
                    {
                        internalType: "string",
                        name: "tokenMetadataURI",
                        type: "string",
                    },
                ],
                internalType: "struct IHederaTokenManager.UpdateTokenStruct",
                name: "updatedToken",
                type: "tuple",
            },
        ],
        name: "updateToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IHederaTokenManager__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.IHederaTokenManager__factory = IHederaTokenManager__factory;
IHederaTokenManager__factory.abi = _abi;
